module.exports = __webpack_public_path__ + "static/media/off_transit.219c2c4b.svg";